import { Icon } from "../Icon.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconViewColumn.tsx
/**
* Confirmed from Figma as the real "Columns" tool glyph — two stacks of four bars. Bar thickness
* increased from the original export's radius-1 pills to radius-1.5 (thicker, per design
* feedback); the viewBox is cropped tightly to the drawn content so it doesn't render smaller
* than the other TableTools icons, which fill more of their own canvas.
*/
const ViewColumnGlyph = (props) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "8.5 10.5 23 19",
	...props,
	children: [
		/* @__PURE__ */ jsx("path", { d: "M17.5 12.5C18.3285 12.5 19 13.1715 19 14C19 14.8285 18.3285 15.5 17.5 15.5H12C11.1715 15.5 10.5 14.8285 10.5 14C10.5 13.1715 11.1715 12.5 12 12.5H17.5Z" }),
		/* @__PURE__ */ jsx("path", { d: "M17.5 16.5C18.3285 16.5 19 17.1715 19 18C19 18.8285 18.3285 19.5 17.5 19.5H12C11.1715 19.5 10.5 18.8285 10.5 18C10.5 17.1715 11.1715 16.5 12 16.5H17.5Z" }),
		/* @__PURE__ */ jsx("path", { d: "M17.5 20.5C18.3285 20.5 19 21.1715 19 22C19 22.8285 18.3285 23.5 17.5 23.5H12C11.1715 23.5 10.5 22.8285 10.5 22C10.5 21.1715 11.1715 20.5 12 20.5H17.5Z" }),
		/* @__PURE__ */ jsx("path", { d: "M17.5 24.5C18.3285 24.5 19 25.1715 19 26C19 26.8285 18.3285 27.5 17.5 27.5H12C11.1715 27.5 10.5 26.8285 10.5 26C10.5 25.1715 11.1715 24.5 12 24.5H17.5Z" }),
		/* @__PURE__ */ jsx("path", { d: "M28 12.5C28.8285 12.5 29.5 13.1715 29.5 14C29.5 14.8285 28.8285 15.5 28 15.5H22.5C21.6715 15.5 21 14.8285 21 14C21 13.1715 21.6715 12.5 22.5 12.5H28Z" }),
		/* @__PURE__ */ jsx("path", { d: "M28 16.5C28.8285 16.5 29.5 17.1715 29.5 18C29.5 18.8285 28.8285 19.5 28 19.5H22.5C21.6715 19.5 21 18.8285 21 18C21 17.1715 21.6715 16.5 22.5 16.5H28Z" }),
		/* @__PURE__ */ jsx("path", { d: "M28 20.5C28.8285 20.5 29.5 21.1715 29.5 22C29.5 22.8285 28.8285 23.5 28 23.5H22.5C21.6715 23.5 21 22.8285 21 22C21 21.1715 21.6715 20.5 22.5 20.5H28Z" }),
		/* @__PURE__ */ jsx("path", { d: "M28 24.5C28.8285 24.5 29.5 25.1715 29.5 26C29.5 26.8285 28.8285 27.5 28 27.5H22.5C21.6715 27.5 21 26.8285 21 26C21 25.1715 21.6715 24.5 22.5 24.5H28Z" })
	]
});
const IconViewColumn = ({ color, height, style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: ViewColumnGlyph,
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconViewColumn };